import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "d-flex justify-content-between" }
const _hoisted_5 = { class: "nav nav-custom nav-tabs nav-line-tabs nav-line-tabs-2x border-0 fs-4 fw-semobold mb-8" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "card-toolbar" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { class: "card-body" }

import { ref, onMounted } from "vue";
import { SiteTypes, ConfigSiteTypesSelections } from "@/core/types/SiteTypes";
import { ConfigCategory } from "@/core/types/ConfigCategory";
import SystemService from "../services/SystemService";
import ConfigList from "../components/config/ConfigList.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'ConfigSetting',
  setup(__props) {

const isLoading = ref(false);
const isReloading = ref(false);
const currentTab = ref(SiteTypes.Default);
const data = ref([]);
const defaultData = ref([]);

const changeTab = (tab) => {
  currentTab.value = tab;
  fetchData();
};

const fetchDefaultData = async () => {
  isLoading.value = true;
  try {
    const res = await SystemService.queryConfig(
      SiteTypes.Default,
      ConfigCategory.public
    );
    defaultData.value = res;
  } catch (e) {
    console.log(e);
  }
  isLoading.value = false;
};

const fetchData = async () => {
  isLoading.value = true;
  try {
    const res = await SystemService.queryConfig(
      currentTab.value,
      ConfigCategory.public
    );
    data.value = res;
  } catch (e) {
    console.log(e);
  }
  isLoading.value = false;
};

const reload = () => {
  isReloading.value = true;
  SystemService.reloadConfiguration().then(() => {
    isReloading.value = false;
  });
};

onMounted(async () => {
  await fetchDefaultData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("ul", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ConfigSiteTypesSelections), (item, index) => {
              return (_openBlock(), _createElementBlock("li", {
                class: "nav-item",
                key: index
              }, [
                _createElementVNode("a", {
                  class: _normalizeClass(["nav-link text-active-primary pb-4", {
                  active: item.value === currentTab.value,
                }]),
                  "data-bs-toggle": "tab",
                  href: "#",
                  onClick: ($event: any) => (changeTab(item.value))
                }, _toDisplayString(item.label), 11, _hoisted_6)
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("button", {
          class: "btn btn-danger btn-sm",
          disabled: isReloading.value,
          onClick: reload
        }, " Reload ", 8, _hoisted_8)
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      (!isLoading.value)
        ? (_openBlock(), _createBlock(ConfigList, {
            key: 0,
            rowId: currentTab.value,
            category: _unref(ConfigCategory).public,
            defaultData: defaultData.value
          }, null, 8, ["rowId", "category", "defaultData"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})